// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file codes/v2/code.proto (package codes.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import { file_google_protobuf_struct } from '@bufbuild/protobuf/wkt'
import type { JsonObject, Message } from '@bufbuild/protobuf'

/**
 * Describes the file codes/v2/code.proto.
 */
export const file_codes_v2_code: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChNjb2Rlcy92Mi9jb2RlLnByb3RvEghjb2Rlcy52MiJBCgpDb2RlRGVzaWduEgoKAmlkGAEgASgJEicKBmNvbmZpZxgCIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QijQEKC0Rlc3RpbmF0aW9uEg0KBXZhbHVlGAEgASgJEioKBHJ1bGUYAiABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SACIAQESJwoEdHlwZRgDIAEoDjIZLmNvZGVzLnYyLkRlc3RpbmF0aW9uVHlwZRIRCglpc19hY3RpdmUYBSABKAhCBwoFX3J1bGUiyAEKBENvZGUSEAoIYmF0Y2hfaWQYASABKAkSEQoJaXNfc3RhdGljGAIgASgIEhEKCXNob3J0X3VybBgDIAEoCRIqCgtkZXN0aW5hdGlvbhgEIAMoCzIVLmNvZGVzLnYyLkRlc3RpbmF0aW9uEikKC2NvZGVfZGVzaWduGAUgASgLMhQuY29kZXMudjIuQ29kZURlc2lnbhIxCg9jcmVhdGlvbl9zb3VyY2UYByABKA4yGC5jb2Rlcy52Mi5DcmVhdGlvblNvdXJjZSrpBgoPRGVzdGluYXRpb25UeXBlEiAKHERFU1RJTkFUSU9OX1RZUEVfVU5TUEVDSUZJRUQQABIYChRERVNUSU5BVElPTl9UWVBFX1VSTBABEhgKFERFU1RJTkFUSU9OX1RZUEVfU01TEAISGgoWREVTVElOQVRJT05fVFlQRV9FVkVOVBADEhkKFURFU1RJTkFUSU9OX1RZUEVfRklMRRAEEhoKFkRFU1RJTkFUSU9OX1RZUEVfVkVOTU8QBRIeChpERVNUSU5BVElPTl9UWVBFX0lOU1RBR1JBTRAGEh0KGURFU1RJTkFUSU9OX1RZUEVfRkFDRUJPT0sQBxIdChlERVNUSU5BVElPTl9UWVBFX0xJTktFRElOEAgSGwoXREVTVElOQVRJT05fVFlQRV9USUtUT0sQCRIdChlERVNUSU5BVElPTl9UWVBFX1NOQVBDSEFUEAoSHAoYREVTVElOQVRJT05fVFlQRV9UV0lUVEVSEAsSHAoYREVTVElOQVRJT05fVFlQRV9TUE9USUZZEAwSHwobREVTVElOQVRJT05fVFlQRV9HT09HTEVfRE9DEA0SHAoYREVTVElOQVRJT05fVFlQRV9ZT1VUVUJFEA4SGwoXREVTVElOQVRJT05fVFlQRV9TT0NJQUwQDxIaChZERVNUSU5BVElPTl9UWVBFX1BIT05FEBASHQoZREVTVElOQVRJT05fVFlQRV9GTE9XUEFHRRAREhkKFURFU1RJTkFUSU9OX1RZUEVfV0lGSRASEiEKHURFU1RJTkFUSU9OX1RZUEVfU09DSUFMX01FRElBEBMSIAocREVTVElOQVRJT05fVFlQRV9TQ0FOX1RPX09XThAUEiUKIURFU1RJTkFUSU9OX1RZUEVfU0NBTl9UT19BQ1RJVkFURRAVEh4KGkRFU1RJTkFUSU9OX1RZUEVfUFJFU0VUX0ZQEBYSIwofREVTVElOQVRJT05fVFlQRV9DT0xMRUNUSUJMRV9GUBAXEiEKHURFU1RJTkFUSU9OX1RZUEVfT05FX1RJTUVfVVJMEBgSGgoWREVTVElOQVRJT05fVFlQRV9WQ0FSRBAZEhkKFURFU1RJTkFUSU9OX1RZUEVfUlVMRRAaEhoKFkRFU1RJTkFUSU9OX1RZUEVfRU1BSUwQGyqPAQoOQ3JlYXRpb25Tb3VyY2USHwobQ1JFQVRJT05fU09VUkNFX1VOU1BFQ0lGSUVEEAASGwoXQ1JFQVRJT05fU09VUkNFX0ZMT1dUQUcQARIfChtDUkVBVElPTl9TT1VSQ0VfU1RBUlRFUl9LSVQQAhIeChpDUkVBVElPTl9TT1VSQ0VfVklERU9fVE9PTBADYgZwcm90bzM',
    [file_google_protobuf_struct]
  )

/**
 * @generated from message codes.v2.CodeDesign
 */
export type CodeDesign = Message<'codes.v2.CodeDesign'> & {
  /**
   * id represents the the studio_config_id
   *
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * The configuration blob that holds the config required to render a flowcode
   *
   * @generated from field: google.protobuf.Struct config = 2;
   */
  config?: JsonObject
}

/**
 * Describes the message codes.v2.CodeDesign.
 * Use `create(CodeDesignSchema)` to create a new message.
 */
export const CodeDesignSchema: GenMessage<CodeDesign> =
  /*@__PURE__*/
  messageDesc(file_codes_v2_code, 0)

/**
 * @generated from message codes.v2.Destination
 */
export type Destination = Message<'codes.v2.Destination'> & {
  /**
   * Value is the redirect_value of the code
   *
   * @generated from field: string value = 1;
   */
  value: string

  /**
   * Rule is an optional redirect rule attached to a code
   *
   * @generated from field: optional google.protobuf.Struct rule = 2;
   */
  rule?: JsonObject

  /**
   * Type describes the "type" of destination a code leads to
   *
   * @generated from field: codes.v2.DestinationType type = 3;
   */
  type: DestinationType

  /**
   * IsActive denotes whether the destination is active or not in the case
   * where multiple destinations are stored per code
   *
   * @generated from field: bool is_active = 5;
   */
  isActive: boolean
}

/**
 * Describes the message codes.v2.Destination.
 * Use `create(DestinationSchema)` to create a new message.
 */
export const DestinationSchema: GenMessage<Destination> =
  /*@__PURE__*/
  messageDesc(file_codes_v2_code, 1)

/**
 * Code is the reprensation of a flowcode containing:
 *   - the data it needs to render an image of it
 *   - the scan destination which determines the interaction a user has when scanning
 *
 * @generated from message codes.v2.Code
 */
export type Code = Message<'codes.v2.Code'> & {
  /**
   * Batch Id represents which batch the code is a part of. The batch is controls the different elements of a code. It's destination, the way it looks in the world, etc.
   * The actual asset.id of a code is synonymous with the Redirect Id
   *
   * @generated from field: string batch_id = 1;
   */
  batchId: string

  /**
   * IsStatic is used to determine if the code is encoded with the short_url or just the value
   *
   * This is primarly used for wifi codes which don't support redirects since the camera needs to read
   * the value directly
   *
   * Any code can be static. Static codes do not collect scan data
   *
   * @generated from field: bool is_static = 2;
   */
  isStatic: boolean

  /**
   * This is the url used to encode the flowcode.
   *
   * Shorturl uses a flowcode domain or in the case of white-label redirects
   * it will contain a different domain
   *
   * @generated from field: string short_url = 3;
   */
  shortUrl: string

  /**
   * Destination describes what happens when a user scans the code
   * Codes can contain multiple active and inactive destinations depending on which is toggle on
   *
   * @generated from field: repeated codes.v2.Destination destination = 4;
   */
  destination: Destination[]

  /**
   * CodeDesign describes what the code looks like
   * The config is fed into the flowcode-generator-v2 which is responsible for interpretting the values
   *
   * @generated from field: codes.v2.CodeDesign code_design = 5;
   */
  codeDesign?: CodeDesign

  /**
   * Deprecated in favor of sticky/internal/persistent tags
   *
   * @generated from field: codes.v2.CreationSource creation_source = 7;
   */
  creationSource: CreationSource
}

/**
 * Describes the message codes.v2.Code.
 * Use `create(CodeSchema)` to create a new message.
 */
export const CodeSchema: GenMessage<Code> = /*@__PURE__*/ messageDesc(file_codes_v2_code, 2)

/**
 * @generated from enum codes.v2.DestinationType
 */
export enum DestinationType {
  /**
   * @generated from enum value: DESTINATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DESTINATION_TYPE_URL = 1;
   */
  URL = 1,

  /**
   * @generated from enum value: DESTINATION_TYPE_SMS = 2;
   */
  SMS = 2,

  /**
   * @generated from enum value: DESTINATION_TYPE_EVENT = 3;
   */
  EVENT = 3,

  /**
   * @generated from enum value: DESTINATION_TYPE_FILE = 4;
   */
  FILE = 4,

  /**
   * @generated from enum value: DESTINATION_TYPE_VENMO = 5;
   */
  VENMO = 5,

  /**
   * @generated from enum value: DESTINATION_TYPE_INSTAGRAM = 6;
   */
  INSTAGRAM = 6,

  /**
   * @generated from enum value: DESTINATION_TYPE_FACEBOOK = 7;
   */
  FACEBOOK = 7,

  /**
   * @generated from enum value: DESTINATION_TYPE_LINKEDIN = 8;
   */
  LINKEDIN = 8,

  /**
   * @generated from enum value: DESTINATION_TYPE_TIKTOK = 9;
   */
  TIKTOK = 9,

  /**
   * @generated from enum value: DESTINATION_TYPE_SNAPCHAT = 10;
   */
  SNAPCHAT = 10,

  /**
   * @generated from enum value: DESTINATION_TYPE_TWITTER = 11;
   */
  TWITTER = 11,

  /**
   * @generated from enum value: DESTINATION_TYPE_SPOTIFY = 12;
   */
  SPOTIFY = 12,

  /**
   * @generated from enum value: DESTINATION_TYPE_GOOGLE_DOC = 13;
   */
  GOOGLE_DOC = 13,

  /**
   * @generated from enum value: DESTINATION_TYPE_YOUTUBE = 14;
   */
  YOUTUBE = 14,

  /**
   * @generated from enum value: DESTINATION_TYPE_SOCIAL = 15;
   */
  SOCIAL = 15,

  /**
   * @generated from enum value: DESTINATION_TYPE_PHONE = 16;
   */
  PHONE = 16,

  /**
   * @generated from enum value: DESTINATION_TYPE_FLOWPAGE = 17;
   */
  FLOWPAGE = 17,

  /**
   * @generated from enum value: DESTINATION_TYPE_WIFI = 18;
   */
  WIFI = 18,

  /**
   * @generated from enum value: DESTINATION_TYPE_SOCIAL_MEDIA = 19;
   */
  SOCIAL_MEDIA = 19,

  /**
   * @generated from enum value: DESTINATION_TYPE_SCAN_TO_OWN = 20;
   */
  SCAN_TO_OWN = 20,

  /**
   * @generated from enum value: DESTINATION_TYPE_SCAN_TO_ACTIVATE = 21;
   */
  SCAN_TO_ACTIVATE = 21,

  /**
   * @generated from enum value: DESTINATION_TYPE_PRESET_FP = 22;
   */
  PRESET_FP = 22,

  /**
   * @generated from enum value: DESTINATION_TYPE_COLLECTIBLE_FP = 23;
   */
  COLLECTIBLE_FP = 23,

  /**
   * @generated from enum value: DESTINATION_TYPE_ONE_TIME_URL = 24;
   */
  ONE_TIME_URL = 24,

  /**
   * @generated from enum value: DESTINATION_TYPE_VCARD = 25;
   */
  VCARD = 25,

  /**
   * @generated from enum value: DESTINATION_TYPE_RULE = 26;
   */
  RULE = 26,

  /**
   * @generated from enum value: DESTINATION_TYPE_EMAIL = 27;
   */
  EMAIL = 27
}

/**
 * Describes the enum codes.v2.DestinationType.
 */
export const DestinationTypeSchema: GenEnum<DestinationType> =
  /*@__PURE__*/
  enumDesc(file_codes_v2_code, 0)

/**
 * Deprecated in favor of a sticky/internal/persistent tag concept
 *
 * @generated from enum codes.v2.CreationSource
 */
export enum CreationSource {
  /**
   * @generated from enum value: CREATION_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREATION_SOURCE_FLOWTAG = 1;
   */
  FLOWTAG = 1,

  /**
   * @generated from enum value: CREATION_SOURCE_STARTER_KIT = 2;
   */
  STARTER_KIT = 2,

  /**
   * @generated from enum value: CREATION_SOURCE_VIDEO_TOOL = 3;
   */
  VIDEO_TOOL = 3
}

/**
 * Describes the enum codes.v2.CreationSource.
 */
export const CreationSourceSchema: GenEnum<CreationSource> =
  /*@__PURE__*/
  enumDesc(file_codes_v2_code, 1)
